import type {MetlApiExport} from "../../metl-models/exports/MetlApiExport.ts";
import type {AxiosInstance} from "axios";

export interface Exportable<T> {
    export(): Promise<MetlApiExport<T>>
}
export function exportable<T, Q extends Exportable<T>>(axios: AxiosInstance, baseUrl: string, remaining: Omit<Q, 'export'>): Q {
    return {
        ...remaining,
        export: async () => {
            const response = await axios.get<MetlApiExport<T>>(`${baseUrl}/export`)
            return response.data
        }
    } as Q
}